export default __webpack_public_path__ + "usergroups.json";